import { Box, Modal, TabMenu, TabMenuItem } from "@bcc-ui/ui-components";
import * as React from "react";

import style from "./dev-tools.scss";
import { DevToolsButton } from "components/dev-tools/dev-tools-button/DevToolsButton";
import { FeatureFlagsSection } from "components/dev-tools/feature-flags/FeatureFlagsSection";

const DEV_TOOLS_SHORTCUT_KEY = "b";
const WIDGET_VISIBLE_SESSION_KEY = "devToolsVisible";

const FEATURE_FLAGS_TAB_INDEX = 0;

function readSessionFlag(key: string): boolean {
    return window.sessionStorage.getItem(key) === "true";
}

function writeSessionFlag(key: string, value: boolean): void {
    window.sessionStorage.setItem(key, String(value));
}

export const DevTools = () => {
    const [isWidgetVisible, setIsWidgetVisible] = React.useState(() => readSessionFlag(WIDGET_VISIBLE_SESSION_KEY));
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [activeTabIndex, setActiveTabIndex] = React.useState(FEATURE_FLAGS_TAB_INDEX);

    React.useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (!event.ctrlKey || !event.altKey || event.key.toLowerCase() !== DEV_TOOLS_SHORTCUT_KEY) {
                return;
            }
            event.preventDefault();
            setIsWidgetVisible((previous) => {
                const next = !previous;
                writeSessionFlag(WIDGET_VISIBLE_SESSION_KEY, next);
                return next;
            });
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    if (!isWidgetVisible) {
        return null;
    }

    return (
        <>
            <DevToolsButton onClick={() => setIsModalOpen(true)} />
            <Modal
                isOpen={isModalOpen}
                hideModal={() => setIsModalOpen(false)}
                title="BMP dev tools"
                width="Lg"
                className={style.devTools}
            >
                <Box columnLayout gap="Lg">
                    <TabMenu>
                        <TabMenuItem
                            key={FEATURE_FLAGS_TAB_INDEX}
                            isActive={activeTabIndex === FEATURE_FLAGS_TAB_INDEX}
                            onClick={() => setActiveTabIndex(FEATURE_FLAGS_TAB_INDEX)}
                        >
                            Feature flags
                        </TabMenuItem>
                    </TabMenu>
                    <FeatureFlagsSection />
                </Box>
            </Modal>
        </>
    );
};
